import React, { useContext } from 'react';
import { Field, useFormikContext } from 'formik';
import { ToggleButton } from 'primereact/togglebutton';
import { showInfoMessage } from '../helper/primereactMessages';
import EdicaoPrecoMensalidadeContext from '../context/EdicaoMensalidadeContext';

export default function Status(){
    const { values, setFieldValue } = useFormikContext();
    const { lotePrecoMensalidadeContextState: { messages } } = useContext(EdicaoPrecoMensalidadeContext);

    const handleChangeStatus = e => {
        const newStatus = e.target.value;

        setFieldValue('status', newStatus? 1 : 0);
        showInfoMessage(messages,`status ${newStatus? 'ativado' : 'desativado'} não se esqueça de salvar/agendar!`);
    };

    return <>
        <Field
            as={ToggleButton}
            name="status"
            id="status"
            disabled={values.atualizarSomenteValorDesconto}
            onChange={handleChangeStatus}
            checked={values.status}
            style={{ width: '100%' }}
            onLabel="Plano ativado"
            offLabel="Plano desativado"
        />
    </>;
}
